export default __webpack_public_path__ + "static/media/NickRiviera.e574982a.png";